import React, { useEffect, useMemo, useRef, useState } from 'react';
import './../../App.css';
import './HomePage.css';

import PageShell from '../../components/layout/PageShell';
import SectionHeader from '../../components/layout/SectionHeader';
import homeVideo from '../../assets/home.mp4';
import AnimeCardSkeleton from '../../components/animecard/AnimeCardSkeleton';
import AnimeRow from '../../components/AnimeRow';
import ApiService from '../../services/ApiService';
import WatchCardComponent from '../../components/watchcard/WatchCardComponent';
import YandexAdComponent from '../../components/YandexAdComponent';
import PlayIcon from '../../assets/ic_play.svg';
import DownloadIcon from '../../assets/download.svg';
import { useNavigate } from 'react-router-dom';
import AppPromo from '../../components/AppPromo';

import RecommendationsComponent from '../../components/RecommendationsComponent';
import adApp from '../../assets/ad_app.png';
import adNy from '../../assets/ad_ny.png';
import AnimixPremiumPopup from '../../components/premium/AnimixPremiumPopup';
import YearRecap from '../../components/yearrecap/YearRecap';

const HomePage = () => {
    const [animeList, setAnimeList] = useState([]);
    const [watchList, setWatchList] = useState([]);
    const [recommendation, setRecommendation] = useState([]);
    const [categories, setCategories] = useState([]);
    const [url, setUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showPremium, setShowPremium] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false); // New state for loading more
    const [page, setPage] = useState(0); // New state for pagination
    const [showRecap, setShowRecap] = useState(false);
    const [recapData, setRecapData] = useState(null);
    const [recapLoading, setRecapLoading] = useState(false);
    const [recapError, setRecapError] = useState(null);
    const videoRef = useRef(null);
    const [account, setAccount] = useState(null);

    const navigate = useNavigate();
    const sessionKey = localStorage.getItem('sessionKey');
    const hasSession = !!sessionKey;
    const showAppDownloadBanner = localStorage.getItem("app") !== "true";
    const recapRequestedRef = useRef(false);
    const recapYear = new Date().getFullYear();
    const isNewYearSeason = useMemo(() => {
        const now = new Date();
        const month = now.getMonth();
        const day = now.getDate();
        return (month === 11 && day >= 20) || (month === 0 && day <= 10);
    }, []);

    var isRecsLoad = false;
    const loadRecap = async () => {
        if (!sessionKey || !isNewYearSeason) {
            return;
        }
        setRecapLoading(true);
        setRecapError(null);
        try {
            const response = await ApiService.getYearRecap(recapYear);
            if (response?.type === "success" && response.data) {
                setRecapData(response.data);
            }
            else {
                setRecapError('Не удалось собрать итоги года');
            }
        }
        catch (e) {
            setRecapError('Не удалось собрать итоги года');
        }
        finally {
            setRecapLoading(false);
        }
    };

    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await ApiService.getSelf();
                if (data.type === "success") {
                    setAccount(data.data);
                    await fetchLastWatch();
                }
            }
            catch (e) { }
            await fetchPublic();


        };

        loadData();
    }, []);

    useEffect(() => {
        if (!sessionKey || !isNewYearSeason) {
            return;
        }
        if (recapRequestedRef.current) {
            return;
        }
        recapRequestedRef.current = true;
        loadRecap();
    }, [sessionKey, recapYear, isNewYearSeason]);

    useEffect(() => {
        const loadData = async () => {
            await fetchRecs(page); // Fetch initial recommendations
        };

        document.title = 'animix - Главная';
        const handleScroll = () => {

            // Detect if scrolled to the bottom of the page
            if (
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100 &&
                !loadingMore
            ) {
                setLoadingMore(true); // Set loading more state
                setPage((prevPage) => prevPage + 1); // Increment page number
                fetchRecs(page + 1); // Fetch more recommendations
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        loadData();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [page, loadingMore]); // Add dependencies for page and loadingMore

    const fetchPublic = async () => {
        try {
            const data = await ApiService.getPublicAnimeList(0);
            if (data.type === "success") {
                setAnimeList(data.data);
            } else {
                console.error('Error fetching anime list:', data);
            }
        } catch (error) {
            // console.error('Error fetching data:', error);
        }
        // Initial content fetched (or attempted) — hide skeletons
        setLoading(false);

        // try {
        //     const catData = await ApiService.getPublicCategories();
        //     if (catData.type === "success") {
        //         setCategories(catData.data);
        //     }
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    };

    const fetchLastWatch = async () => {
        try {
            const watchData = await ApiService.getLastWatch();
            if (watchData.type === "success") {
                setWatchList(watchData.data);
            }
        } catch (error) {
            //    console.error('Error fetching data:', error);
        }
    };

    const fetchRecs = async (page = 0) => {
        try {
            if (!isRecsLoad) {
                isRecsLoad = true;
                const recsArray = await ApiService.getRecs(page); // Pass page to API

                if (recsArray.type === "success") {
                    setRecommendation((prevRecs) => [
                        ...prevRecs,
                        recsArray.data, // Append new recommendations
                    ]);
                }
                setLoadingMore(false); // Reset loading state for more recommendations
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoadingMore(false);
        }
    };

    const handleLoad = () => {
        if (videoRef.current != null) {
            if (videoRef.current.currentTime < 50) {
                videoRef.current.currentTime = 50;
            }
        }
    };

    return (
        <PageShell
            sidebar
            className="home-page page-shell--bleed"
            bodyClassName="home-main-hor-con"
            mainClassName="feed"
        >
                    <div className='home-player-top'>
                        {url == null ? (
                            <video key={homeVideo} autoPlay loop muted>
                                <source src={homeVideo} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        ) : (
                            <video key={url} ref={videoRef} onPlay={handleLoad} autoPlay loop muted>
                                <source src={url} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        )}

                        <div className={`home-overlay ${hasSession ? '' : 'home-overlay--guest'}`}>
                            <div className="home-title">
                                <h1 className="title">Реинкарнация безработного</h1>
                                <p>Новый сезон получился очень крутым — смотреть обязательно</p>
                            </div>
                            {hasSession ? (
                                <a href={`/anime/908`} className='actionButton playButton head'>
                                    <img src={PlayIcon} alt="Play Icon" className="playIcon" />Смотреть
                                </a>
                            ) : null}
                        </div>
                    </div>

                    {isNewYearSeason ? (
                        <>
                            <div className="year-recap-banner">
                                <div className="year-recap-banner__glow" />
                                <div className="year-recap-banner__content">
                                    <div className="yrb-top">
                                        <span className="yrb-pill">Year recap {recapYear}</span>
                                        {hasSession ? (
                                            recapLoading ? <span className="yrb-status">Считаем...</span> : recapError ? <span className="yrb-status error">Не получилось</span> : <span className="yrb-status success">Готово</span>
                                        ) : <span className="yrb-status">Требуется вход</span>}
                                    </div>
                                    <h2>Истории твоего аниме-года</h2>
                                    <p className="yrb-sub">Открой сторис с марафонами, жанрами и топовыми тайтлами.</p>
                                    <div className="yrb-actions">
                                        {hasSession ? (
                                            <button
                                                className="yrb-btn"
                                                disabled={recapLoading || !recapData}
                                                onClick={() => setShowRecap(true)}
                                            >
                                                Смотреть истории
                                            </button>
                                        ) : (
                                            <button className="yrb-btn" onClick={() => navigate('/login')}>
                                                Войти
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="full-width-da-block">
                                <img src={adNy} alt="Ad Background" />
                                <h1>Новогодний марафон на анимикс</h1>
                                <p className="da-text">Проведи выходные вместе с нами, мы подготовили подборку новогодних аниме</p>
                                <div>
                                    {hasSession ? (
                                        <button className="da-button" onClick={() => navigate("/category/152")}>
                                            Смотреть
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                        </>
                    ) : null}

                    <div className='animeblock'>
                        {loading ? (
                            <>
                                <div className="container-wrapper">
                                    <SectionHeader title="Всё аниме" to="/all" />
                                    <div className="anime-line-container-padding">
                                        <div className="anime-line-container">
                                            {Array.from({ length: 10 }).map((_, i) => (
                                                <AnimeCardSkeleton key={`skeleton-${i}`} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                {hasSession && watchList.length > 0 && (
                                    <div className="container-wrapper">
                                        <SectionHeader title="Продолжить просмотр" />
                                        <div className="watch-container">
                                            {watchList.map((watchSnippet) => (
                                                <WatchCardComponent key={watchSnippet.id} watchSnippet={watchSnippet} isInteractive={true} />
                                            ))}
                                        </div>
                                    </div>
                                )}

                                <AnimeRow title="Всё аниме" items={animeList} to="/all" />
                                {localStorage.getItem("subscribed") == true ? "" : (
                                    <YandexAdComponent blockId={localStorage.getItem("subscribed") ? `` : `R-A-8131234-1`} />
                                )}
                                <div className="full-width-da-block">
                                    <img src={adApp} alt="Ad Background" />
                                    <p className="da-text">Не потеряйте нас. Приложение на ПК и Android или Телеграм. Лучше сайта.</p>
                                    <div>
                                        <button className="da-button" onClick={() => window.open("https://animixapp.ety.one")}>
                                            Скачать
                                        </button>
                                        <button className="da-button" onClick={() => window.open("https://t.me/animixlib")}>
                                            Telegram
                                        </button>
                                    </div>
                                </div>
                                {localStorage.getItem("subscribed") == true ? "" : <YandexAdComponent blockId="R-A-8131234-2" />}
                                {recommendation.map((rec, index) => (
                                    <RecommendationsComponent key={index} recs={rec} />
                                ))}
                                {loadingMore && <div className="loader"></div>} {/* Show loader when loading more */}
                            </>
                        )}
                    </div>

            {showAppDownloadBanner ?   <div className='down-bt' onClick={() => { window.open("https://animixapp.ety.one") }}>
                <img src={DownloadIcon} />
                <p>  Сайт может перестать работать в любой момент. Скачайте приложение тут.</p>
            </div> : ''}

            {showRecap && recapData ? (
                <YearRecap
                    data={recapData}
                    year={recapData.year || recapYear}
                    onClose={() => setShowRecap(false)}
                />
            ) : ''}

            <AppPromo />
            {showPremium ? <AnimixPremiumPopup onClose={() => {
                setShowPremium(false);
            }} /> : ""}
        </PageShell>
    );
};

export default HomePage;
